export interface Fornecedor {
    [key:string] : string | number | undefined | Date;
    CA2COD: string;
    CA2LOJA: string;
    CA2NOME: string;
    CA2NREDUZ: string;
    CA2CONTATO: string;
    CA2CEP: string;
    CA2END: string;
    CA2COMPLEM: string;
    CA2BAIRRO: string;
    CA2EST: string;
    CA2COD_MUN: string;
    CA2MUN: string;
    CA2CGC: string;
    CA2INSCR: string;
    CA2INSCRM: string;
    CA2DDD: string;
    CA2TEL: string;
    CA2NATUREZ: string;
    CA2COND: string;
    CA2CONTA: string;
    CA2EMAIL: string;
    CA2CODPAIS: string;
    CA2PAIS: string;
    CA2BANCO: string;
    CA2AGENCIA: string;
    CA2DVAGE: string;
    CA2NUMCON: string;
    CA2DVCTA: string;
    CA2PFISICA: string;
    CA2CX_POST: string;
    CA2DDI: string;
    CA2FAX: string;
    CA2HPAGE: string;
    CA2TIPO: string;
    CA2MSBLQL: string;
    NA2RECNO: number;
}

export interface FornecedorDtoList {
    items: Array<Fornecedor>;
}


export const getFornecedorDefault = (): Fornecedor => {
    return {
        CA2COD: '',
        CA2LOJA: '',
        CA2NOME: '',
        CA2NREDUZ: '',
        CA2CONTATO: '',
        CA2CEP: '',
        CA2END: '',
        CA2COMPLEM: '',
        CA2BAIRRO: '',
        CA2EST: '',
        CA2COD_MUN: '',
        CA2MUN: '',
        CA2CGC: '',
        CA2INSCR: '',
        CA2INSCRM: '',
        CA2DDD: '',
        CA2TEL: '',
        CA2NATUREZ: '',
        CA2COND: '',
        CA2CONTA: '',
        CA2EMAIL: '',
        CA2CODPAIS: '',
        CA2PAIS: '',
        CA2BANCO: '',
        CA2AGENCIA: '',
        CA2DVAGE: '',
        CA2NUMCON: '',
        CA2DVCTA: '',
        CA2PFISICA: '',
        CA2CX_POST: '',
        CA2DDI: '',
        CA2FAX: '',
        CA2HPAGE: '',
        CA2TIPO: '',
        CA2MSBLQL: '',
        NA2RECNO: 0,
    };
};

export interface FornecedorCurto {
    CA2COD: string;
    CA2LOJA: string;
    CA2NOME: string;
    CA2NREDUZ: string;
    CA2MUN: string;
    CA2EST: string;
    CA2CGC: string;
    NA2RECNO: number;
}

export interface FornecedorFornecedorCurtoDtoList {
    items: Array<FornecedorCurto>;
}

export const getFornecedorCurtoDefault = (): FornecedorCurto => {
    return {
        CA2COD: '',
        CA2LOJA: '',
        CA2NOME: '',
        CA2NREDUZ: '',
        CA2MUN: '',
        CA2EST: '',
        CA2CGC: '',
        NA2RECNO: 0,
    };
};


